export default function Contact() {
  return (
    <div>
      To request a new language or report an issue, please contact us at{' '}
      <a href="mailto:support@meovak.com">support@meovak.com</a>
    </div>
  );
}
